import { apiFetch } from './client';
import type { WorkspaceResumen } from '@/store/workspace.store';

/**
 * Negocios (workspaces) del usuario. Prefijo: /api/workspaces
 *
 * Es la única llamada exenta del guard de workspace en el servidor: para poder
 * ELEGIR un negocio primero hay que poder listarlos.
 */
export interface WorkspacesResponse {
  items: WorkspaceResumen[];
  /** ¿La instancia admite varios negocios? (`MULTI_WORKSPACE_ENABLED`). */
  multiWorkspace: boolean;
  /** ¿Se pinta el selector? Lo decide el servidor, no el panel. */
  mostrarSelector: boolean;
}

export function listWorkspaces(): Promise<WorkspacesResponse> {
  return apiFetch<WorkspacesResponse>('/api/workspaces');
}
